import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'
import { Inbox } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface EmptyStateProps {
  title: string
  description?: string
  icon?: LucideIcon
  action?: ReactNode
  className?: string
}

/** Shown when a list has no rows — distinct from the error state, which offers a retry. */
export function EmptyState({
  title,
  description,
  icon: Icon = Inbox,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center px-6 py-14 text-center', className)}>
      <span className="grid size-14 place-items-center rounded-2xl bg-[var(--color-primary-soft)] ring-8 ring-[var(--color-primary-soft)]/40">
        <Icon className="size-6 text-[var(--color-primary)]" aria-hidden="true" />
      </span>
      <p className="mt-5 text-[15px] font-semibold text-[var(--color-heading)]">{title}</p>
      {description && <p className="mt-1 max-w-sm text-sm text-[var(--color-muted)]">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
